import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { Button, Grid, Group, IconButton, Layout, Page, Tree } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useToast, useModal, useTree, usePopup, usePage } from "@/comn/hooks";
import {
    APIS,
    URLS,
    SF_APRV_RQST_PPUP_INFO,
    SG_APRV_PATH_RQST_LIST,
    SG_APRV_CSTM_USR_LIST,
    SG_APRV_USR_LIST,
    SG_CSTM_LIST,
    SF_CSTM_OFCR_SRCH,
    SG_APRV_ORG_USR_LIST,
} from "./service/OgaAprvService";
import { LayoutGroup } from "framer-motion";

/*
 * Popup for Approval Request
 * !== 결재 요청 팝업 ==!
 */
export const OgaAprvRqstUsrLst = (props: any): JSX.Element => {
    const { paramData, callbackFn } = props;
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const tree = useTree(); // Tree Hook !== Tree Hook ==!
    // const { getParams } = usePopup();

    const uTree = useTree({
        _checkbox: false,
        _checked: [],
    });

    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    const [orgDeptTree, setOrgDeptTree] = useState([]);

    const [orgDeptUsrList, setOrgDeptUsrList] = useState(comnUtils.getGridData([]));

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Customs Search !== 세관 검색 ==!
        cstmOfcrSrch: useForm({
            defaultSchema: SF_CSTM_OFCR_SRCH,
        }),

        // Approval Request Popup Information Form !== 결재 요청 팝업 정보 form ==!
        aprvRqstPpupInfo: useForm({
            defaultSchema: SF_APRV_RQST_PPUP_INFO,
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Customs list inquiry !== 세관 목록 조회 ==!
        cstmList: useGrid({
            defaultSchema: SG_CSTM_LIST,
        }),
        // When selecting a Customs Office, check the list of target approver List !== 세관 선택시 대상자 목록 조회 ==!
        aprvCstmUsrList: useGrid({
            // defaultSchema: SG_APRV_CSTM_USR_LIST,
            defaultSchema: SG_APRV_ORG_USR_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // When selecting an Organization Chart, View the List of Target User List  !== 조직도 선택시 대상자 목록 조회 ==!
        getCstmList: useFetch({
            api: (data: any) => APIS.getOrgDeptHierarchyList(),
            onSuccess: (data) => {
                console.log("getCstmList", data);
                let treeData = data.orgDeptTreeData?.content;
                setOrgDeptTree(treeData);
                uTree.setData(treeData);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // 조회가 실패하였습니다.
        }),

        getOrgDeptUsrList: useFetch({
            api: () => {
                // Only users holding the authority required to approve are listed !== 결재에 필요한 권한 보유자만 결재자 후보로 조회 ==!
                return APIS.getOrgDeptUsrList({
                    ...form.cstmOfcrSrch.getValues(),
                    authId: paramData?.authId,
                });
            },
            onSuccess: (data) => {
                const userList = data?.usrList?.content || [];
                setOrgDeptUsrList(comnUtils.getGridData(userList));
            },
            onError: () => {},
            showToast: false,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Approval User List !== 결재 사용자 목록 조회 ==!
        getAprvUsrList: () => {
            form.cstmOfcrSrch.handleSubmit(
                (data) => {
                    fetch.getOrgDeptUsrList.fetch();
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        createTreeData: (orgList: any, newList: any, level: any, menuId: any) => {
            const tempList = orgList.map((item: any) => {
                return {
                    name: comnUtils.replaceEmpty(item.cstmNm),
                    checkbox: false,
                    cstmOfceCd: comnUtils.replaceEmpty(item.cstmOfceCd),
                };
            });

            return tempList;
        },

        getOrgDeptUsrList: (orgCd: any, deptCd: any) => {
            // TODO KNH 조회 조건과 관련된 내용 초기화
            form.cstmOfcrSrch.setValues({ usrDmnId: "", usrNm: "" });
            // TODO KNH 선택한 부서 정보 설정
            form.cstmOfcrSrch.setValues({ orgCd: orgCd, deptCd: deptCd });
            fetch.getOrgDeptUsrList.fetch();
        },

        onBtnAdd: () => {
            const trgtUsrList = grid.aprvCstmUsrList.getChecked(); // Approver Target List !== 결재자 대상 선택 목록 ==!
            console.log("trgtUsrList", trgtUsrList);
            if (trgtUsrList.length === 0) {
                modal.openModal({ content: "msg.osc.00197" }); // Please select a registration target !== 등록대상을 선택하세요. ==!
                return;
            }

            // modal.postMessage({
            //     trgtUsrList: trgtUsrList,
            // });
            if (callbackFn) {
                callbackFn(trgtUsrList);
            } else {
                // TODO KNH 메시지를 표시할 것인지? 아니면 그냥 창을 닫을 것인지 확인 필요.
            }
        },

        onClickClose: () => {
            modal.closeModal("OgaAprvRqstUsrLst");
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getCstmList.fetch();
        tree.tree._tree.current._checkbox = false;
    }, []);

    return (
        <Page title={t("Officer List")} info={true}>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrSrch.schema.usrId}></Group.Control>
                            <Group.Control {...form.cstmOfcrSrch.schema.usrNm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.cstmOfcrSrch.reset();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getAprvUsrList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            {/* </form> */}
            <Group>
                <Group.Body>
                    <Layout height={400}>
                        {/* <Group> */}
                        <Layout>
                            <Group.Body>
                                <Group.Title title={t("List of Organizations")} titleSize={3} />
                                <Tree
                                    data={orgDeptTree}
                                    onClick={(data: any) => {
                                        const { orgCd, deptCd } = data;
                                        handler.getOrgDeptUsrList(orgCd, deptCd);
                                    }}
                                    _tree={uTree.tree._tree}
                                    size={12}
                                    height={310}
                                    checkbox={false}
                                />
                            </Group.Body>
                            {/* </Group> */}
                        </Layout>
                        {/* <Group> */}
                        <Layout>
                            <Group.Body>
                                <Group.Section>
                                    <Grid {...grid.aprvCstmUsrList.grid} data={orgDeptUsrList} />
                                </Group.Section>
                            </Group.Body>
                            {/* </Group> */}
                        </Layout>
                    </Layout>
                </Group.Body>
            </Group>
            <Layout.Right>
                <Button role="add" onClick={handler.onBtnAdd} />
                <Button role="close" onClick={handler.onClickClose} />
            </Layout.Right>
            <Layout gap={2}></Layout>
        </Page>
    );
};
